<template>
    <Link :href="'/'">
        <img
            src="/images/logo.png"
            style="max-width: 325px;"
        />
    </Link>
</template>

<script>
    import { Link } from '@inertiajs/inertia-vue3';

    export default {
        components: {
            Link,
        },
    }
</script>
